// v4 billing pricing

export const v4Features = {
  trialFeatures: [
    {
      header: "What's included:",
      features: [],
      style: { textAlign: 'center', color: 'rgba(80, 80, 80, 1)', marginBottom: '0px' },
    },
    {
      header: 'Multi-channel SMS and Live Chat Platform',
      features: [
        { body: 'Unlimited Users' },
        { body: '1 Avochato Number' },
        { body: '$5 Account Balance' },
        { body: 'Send up to 50 contacts' },
        { body: 'All Premium features' },
      ],
    },
  ],
  liteFeatures: [
    {
      header: "What's included:",
      features: [],
      style: { textAlign: 'center', color: 'rgba(80, 80, 80, 1)', marginBottom: '0px' },
    },
    {
      header: 'Multi-channel SMS and Live Chat Platform',
      features: [
        {
          body: '1 Unique Phone Numbers',
          hover: {
            header: 'Phone Numbers:',
            body: "Each phone number is reserved for your business. It's your personal line, so you can put it on a business card, or a billboard, or your website – wherever you want.",
          },
        },
        { body: 'Unlimited Live Chat Messages' },
        { body: 'Customizable Website Widget' },
      ],
    },
    {
      header: 'Basic Two-way Conversation Management',
      features: [
        { body: 'Auto-responses' },
        { body: 'Tagging' },
      ],
    },
  ],
  standardFeatures: [
    {
      header: 'All Lite features, plus:',
      features: [],
      style: { textAlign: 'center', color: 'rgba(80, 80, 80, 1)', marginBottom: '0px' },
    },
    {
      header: 'Marketing Features',
      features: [
        { body: 'Broadcast Messages' },
        { body: 'Link Click Tracker' },
      ],
    },
    {
      header: 'Advanced Team Management Functionality',
      features: [
        { body: 'Skill Routing' },
        { body: 'Dispositions' },
      ],
    }, {
      header: 'Automation Tools',
      features: [
        { body: 'Drip Campaigns' },
        { body: 'Surveys' },
      ],
    }, {
      header: 'Integrations',
      features: [
        { body: 'Salesforce Data Syncing' },
        { body: 'Zapier' },
        { body: 'Microsoft Teams' },
        { body: 'Slack' },
      ],
    },
  ],
  premiumFeatures: [
    {
      header: 'All Standard features, plus:',
      features: [],
      style: { textAlign: 'center', color: 'rgba(80, 80, 80, 1)', marginBottom: '0px' },
    },
    {
      header: 'Enterprise-grade Workflows and Control',
      features: [
        { body: 'Access to Avochato’s API' },
        { body: 'Salesforce Process Builder Workflows' },
        { body: 'HIPAA Compliance' },
        { body: 'Dedicated Account Rep' },
      ],
    },
  ],
};

export const v4PlanColumnDatas = {
  trial: {
    id: 'trial-plan-4',
    name: 'Trial',
    nameColor: 'teal',
    featureSections: v4Features.trialFeatures,
  },
  lite: {
    id: 'lite-plan-4',
    name: 'Lite',
    nameColor: 'light-green',
    featureSections: v4Features.liteFeatures,
  },
  standard: {
    id: 'standard-plan-4',
    name: 'Standard',
    nameColor: 'burnt-orange',
    featureSections: v4Features.standardFeatures,
  },
  premium: {
    id: 'custom',
    name: 'Premium',
    nameColor: 'dark-green',
    featureSections: v4Features.premiumFeatures,
  },
};

export const balances = [
  25, 50, 75, 100, 200, 250, 300, 400, 500, 750, 1000, 1250, 1500,
  2000, 2500, 3000, 4000, 5000, 10000,
];
export const trialBonus = 5;
export const v4PlanPrices = {
  'trial-plan-4': {
    seatPrice: 0,
    platformPrice: 0,
    bonusBalancePerSeat: 5,
  },
  'lite-plan-4-monthly': {
    seatPrice: 23,
    platformPrice: 0,
    bonusBalancePerSeat: 5,
  },
  'lite-plan-4-annual': {
    seatPrice: 19,
    platformPrice: 0,
    bonusBalancePerSeat: 10,
  },
  'standard-plan-4-monthly': {
    seatPrice: 42,
    platformPrice: 210,
    bonusBalancePerSeat: 10,
  },
  'standard-plan-4-annual': {
    seatPrice: 35,
    platformPrice: 175,
    bonusBalancePerSeat: 20,
  },
};

export const annualize = (monthlyPrice) => monthlyPrice * 12;
export const calcPriceTotal = (payPeriod, monthlyPrice) => {
  if (payPeriod === 'monthly') return monthlyPrice;
  return annualize(monthlyPrice);
};

export const regions = [
  'ad', 'ae', 'af', 'ag', 'ai', 'al', 'am', 'an', 'ao', 'ar', 'as', 'at', 'au', 'aw', 'az', 'ba', 'bb', 'bd', 'be', 'bf', 'bg', 'bh', 'bi', 'bj', 'bm', 'bn', 'bo', 'br', 'bs', 'bt', 'bw', 'by', 'bz', 'ca', 'cd', 'cf', 'cg', 'ch', 'ci', 'ck', 'cl', 'cm', 'cn', 'co', 'cr', 'cu', 'cv', 'cy', 'cz', 'de', 'dj', 'dk', 'dm', 'do', 'dz', 'ec', 'ee', 'eg', 'er', 'es', 'et', 'fi', 'fj', 'fk', 'fm', 'fo', 'fr', 'ga', 'gb', 'gd', 'ge', 'gf', 'gg', 'gh', 'gi', 'gl', 'gm', 'gn', 'gp', 'gq', 'gr', 'gt', 'gu', 'gw', 'gy', 'hk', 'hn', 'hr', 'ht', 'hu', 'indo', 'ie', 'il', 'in', 'iq', 'ir', 'is', 'it', 'je', 'jm', 'jo', 'jp', 'ke', 'kg', 'kh', 'ki', 'km', 'kn', 'kr', 'kw', 'ky', 'kz', 'la', 'lb', 'lc', 'li', 'lk', 'lr', 'ls', 'lt', 'lu', 'lv', 'ly', 'ma', 'mc', 'md', 'me', 'mg', 'mh', 'mk', 'ml', 'mm', 'mn', 'mo', 'mp', 'mq', 'mr', 'ms', 'mt', 'mu', 'mv', 'mw', 'mx', 'my', 'mz', 'na', 'nc', 'ne', 'nf', 'ng', 'ni', 'nl', 'no', 'np', 'nu', 'nz', 'om', 'pa', 'pe', 'pf', 'pg', 'ph', 'pk', 'pl', 'pm', 'pr', 'ps', 'pt', 'pw', 'py', 'qa', 're', 'ro', 'rs', 'ru', 'rw', 'sa', 'sb', 'sc', 'sd', 'se', 'sg', 'si', 'sk', 'sl', 'sm', 'sn', 'so', 'sr', 'ss', 'st', 'sv', 'sy', 'sz', 'tc', 'td', 'tg', 'th', 'tj', 'tl', 'tm', 'tn', 'to', 'tr', 'tt', 'tv', 'tw', 'tz', 'ua', 'ug', 'uy', 'us', 'uz', 'vc', 've', 'vg', 'vi', 'vn', 'vu', 'wf', 'ws', 'xk', 'ye', 'za', 'zm', 'zw',
];

export const regionRates = {
  ad: { fullName: 'Andorra', rate: { monthly: 0.05, annual: 0.05 } },
  ae: { fullName: 'United Arab Emirates', rate: { monthly: 0.04, annual: 0.04 } },
  af: { fullName: 'Afghanistan', rate: { monthly: 0.10, annual: 0.10 } },
  ag: { fullName: 'Antigua and Barbuda', rate: { monthly: 0.05, annual: 0.05 } },
  ai: { fullName: 'Anguilla', rate: { monthly: 0.06, annual: 0.06 } },
  al: { fullName: 'Albania', rate: { monthly: 0.10, annual: 0.10 } },
  am: { fullName: 'Armenia', rate: { monthly: 0.10, annual: 0.10 } },
  an: { fullName: 'Netherlands Antilles', rate: { monthly: 0.06, annual: 0.06 } },
  ao: { fullName: 'Angola', rate: { monthly: 0.08, annual: 0.08 } },
  ar: { fullName: 'Argentina', rate: { monthly: 0.08, annual: 0.08 } },
  as: { fullName: 'American Samoa', rate: { monthly: 0.14, annual: 0.14 } },
  at: { fullName: 'Austria', rate: { monthly: 0.11, annual: 0.11 } },
  au: { fullName: 'Australia', rate: { monthly: 0.10, annual: 0.10 } },
  aw: { fullName: 'Aruba', rate: { monthly: 0.06, annual: 0.06 } },
  az: { fullName: 'Azerbaijan', rate: { monthly: 0.17, annual: 0.17 } },
  ba: { fullName: 'Bosnia and Herzegovina', rate: { monthly: 0.10, annual: 0.10 } },
  bb: { fullName: 'Barbados', rate: { monthly: 0.06, annual: 0.06 } },
  bd: { fullName: 'Bangladesh', rate: { monthly: 0.09, annual: 0.09 } },
  be: { fullName: 'Belgium', rate: { monthly: 0.12, annual: 0.12 } },
  bf: { fullName: 'Burkina Faso', rate: { monthly: 0.08, annual: 0.08 } },
  bg: { fullName: 'Bulgaria', rate: { monthly: 0.16, annual: 0.16 } },
  bh: { fullName: 'Bahrain', rate: { monthly: 0.14, annual: 0.14 } },
  bi: { fullName: 'Burundi', rate: { monthly: 0.12, annual: 0.12 } },
  bj: { fullName: 'Benin', rate: { monthly: 0.13, annual: 0.13 } },
  bm: { fullName: 'Bermuda', rate: { monthly: 0.06, annual: 0.06 } },
  bn: { fullName: 'Brunei', rate: { monthly: 0.06, annual: 0.06 } },
  bo: { fullName: 'Bolivia', rate: { monthly: 0.08, annual: 0.08 } },
  br: { fullName: 'Brazil', rate: { monthly: 0.07, annual: 0.07 } },
  bs: { fullName: 'Bahamas', rate: { monthly: 0.06, annual: 0.06 } },
  bt: { fullName: 'Bhutan', rate: { monthly: 0.06, annual: 0.06 } },
  bw: { fullName: 'Botswana', rate: { monthly: 0.11, annual: 0.11 } },
  by: { fullName: 'Belarus', rate: { monthly: 0.10, annual: 0.10 } },
  bz: { fullName: 'Belize', rate: { monthly: 0.08, annual: 0.08 } },
  ca: {
    fullName: 'Canada',
    rate: {
      sms_monthly: 0.03,
      mms_monthly: 0.04,
      call_monthly: 0.03,
      sms_annual: 0.02,
      mms_annual: 0.03,
      call_annual: 0.02,
    },
  },
  cd: { fullName: 'DR Congo', rate: { monthly: 0.11, annual: 0.11 } },
  cf: { fullName: 'Central Africa', rate: { monthly: 0.06, annual: 0.06 } },
  cg: { fullName: 'Congo', rate: { monthly: 0.08, annual: 0.08 } },
  ch: { fullName: 'Switzerland', rate: { monthly: 0.10, annual: 0.10 } },
  ci: { fullName: 'Ivory Coast', rate: { monthly: 0.18, annual: 0.18 } },
  ck: { fullName: 'Cook Islands', rate: { monthly: 0.06, annual: 0.06 } },
  cl: { fullName: 'Chile', rate: { monthly: 0.09, annual: 0.09 } },
  cm: { fullName: 'Cameroon', rate: { monthly: 0.17, annual: 0.17 } },
  cn: { fullName: 'China', rate: { monthly: 0.08, annual: 0.08 } },
  co: { fullName: 'Colombia', rate: { monthly: 0.06, annual: 0.06 } },
  cr: { fullName: 'Costa Rica', rate: { monthly: 0.08, annual: 0.08 } },
  cu: { fullName: 'Cuba', rate: { monthly: 0.10, annual: 0.10 } },
  cv: { fullName: 'Cape Verde', rate: { monthly: 0.09, annual: 0.09 } },
  cy: { fullName: 'Cyprus', rate: { monthly: 0.10, annual: 0.10 } },
  cz: { fullName: 'Czech Republic', rate: { monthly: 0.08, annual: 0.08 } },
  de: { fullName: 'Germany', rate: { monthly: 0.12, annual: 0.12 } },
  dj: { fullName: 'Djibouti', rate: { monthly: 0.12, annual: 0.12 } },
  dk: { fullName: 'Denmark', rate: { monthly: 0.10, annual: 0.10 } },
  dm: { fullName: 'Dominica', rate: { monthly: 0.06, annual: 0.06 } },
  do: { fullName: 'Dominican Republic', rate: { monthly: 0.07, annual: 0.07 } },
  dz: { fullName: 'Algeria', rate: { monthly: 0.09, annual: 0.09 } },
  ec: { fullName: 'Ecuador', rate: { monthly: 0.11, annual: 0.11 } },
  ee: { fullName: 'Estonia', rate: { monthly: 0.12, annual: 0.12 } },
  eg: { fullName: 'Egypt', rate: { monthly: 0.10, annual: 0.10 } },
  er: { fullName: 'Eritrea', rate: { monthly: 0.12, annual: 0.12 } },
  es: { fullName: 'Spain', rate: { monthly: 0.1501, annual: 0.1501 } },
  et: { fullName: 'Ethiopia', rate: { monthly: 0.08, annual: 0.08 } },
  fi: { fullName: 'Finland', rate: { monthly: 0.10, annual: 0.10 } },
  fj: { fullName: 'Fiji', rate: { monthly: 0.12, annual: 0.12 } },
  fk: { fullName: 'Falkland Islands', rate: { monthly: 0.08, annual: 0.08 } },
  fm: { fullName: 'Micronesia', rate: { monthly: 0.08, annual: 0.08 } },
  fo: { fullName: 'Faroe Islands', rate: { monthly: 0.07, annual: 0.07 } },
  fr: { fullName: 'France', rate: { monthly: 0.12, annual: 0.12 } },
  ga: { fullName: 'Gabon', rate: { monthly: 0.08, annual: 0.08 } },
  gb: { fullName: 'United Kingdom', rate: { monthly: 0.07, annual: 0.07 } },
  gd: { fullName: 'Grenada', rate: { monthly: 0.07, annual: 0.07 } },
  ge: { fullName: 'Georgia', rate: { monthly: 0.11, annual: 0.11 } },
  gf: { fullName: 'French Guiana', rate: { monthly: 0.22, annual: 0.22 } },
  gg: { fullName: 'Guernsey', rate: { monthly: 0.05, annual: 0.05 } },
  gh: { fullName: 'Ghana', rate: { monthly: 0.08, annual: 0.08 } },
  gi: { fullName: 'Gibraltar', rate: { monthly: 0.08, annual: 0.08 } },
  gl: { fullName: 'Greenland', rate: { monthly: 0.08, annual: 0.08 } },
  gm: { fullName: 'Gambia', rate: { monthly: 0.08, annual: 0.08 } },
  gn: { fullName: 'Guinea', rate: { monthly: 0.18, annual: 0.18 } },
  gp: { fullName: 'Guadeloupe', rate: { monthly: 0.11, annual: 0.11 } },
  gq: { fullName: 'Equatorial Guinea', rate: { monthly: 0.05, annual: 0.05 } },
  gr: { fullName: 'Greece', rate: { monthly: 0.08, annual: 0.08 } },
  gt: { fullName: 'Guatemala', rate: { monthly: 0.08, annual: 0.08 } },
  gu: { fullName: 'Guam', rate: { monthly: 0.11, annual: 0.11 } },
  gw: { fullName: 'Guinea-Bissau', rate: { monthly: 0.18, annual: 0.18 } },
  gy: { fullName: 'Guyana', rate: { monthly: 0.06, annual: 0.06 } },
  hk: { fullName: 'Hong Kong', rate: { monthly: 0.08, annual: 0.08 } },
  hn: { fullName: 'Honduras', rate: { monthly: 0.08, annual: 0.08 } },
  hr: { fullName: 'Croatia', rate: { monthly: 0.08, annual: 0.08 } },
  ht: { fullName: 'Haiti', rate: { monthly: 0.08, annual: 0.08 } },
  hu: { fullName: 'Hungary', rate: { monthly: 0.11, annual: 0.011 } },
  indo: { fullName: 'Indonesia', rate: { monthly: 0.06, annual: 0.03 } },
  ie: { fullName: 'Ireland', rate: { monthly: 0.13, annual: 0.03 } },
  il: { fullName: 'Israel', rate: { monthly: 0.03, annual: 0.03 } },
  in: { fullName: 'India', rate: { monthly: 0.01, annual: 0.01 } },
  iq: { fullName: 'Iraq', rate: { monthly: 0.13, annual: 0.13 } },
  ir: { fullName: 'Iran', rate: { monthly: 0.06, annual: 0.06 } },
  is: { fullName: 'Iceland', rate: { monthly: 0.03, annual: 0.03 } },
  it: { fullName: 'Italy', rate: { monthly: 0.1766, annual: 0.1766 } },
  je: { fullName: 'Jersey', rate: { monthly: 0.05, annual: 0.05 } },
  jm: { fullName: 'Jamaica', rate: { monthly: 0.08, annual: 0.08 } },
  jo: { fullName: 'Jordan', rate: { monthly: 0.11, annual: 0.11 } },
  jp: { fullName: 'Japan', rate: { monthly: 0.10, annual: 0.10 } },
  ke: { fullName: 'Kenya', rate: { monthly: 0.08, annual: 0.08 } },
  kg: { fullName: 'Kyrgyzstan', rate: { monthly: 0.07, annual: 0.07 } },
  kh: { fullName: 'Cambodia', rate: { monthly: 0.13, annual: 0.13 } },
  ki: { fullName: 'Kiribati', rate: { monthly: 0.10, annual: 0.10 } },
  km: { fullName: 'Comoros', rate: { monthly: 0.08, annual: 0.08 } },
  kn: { fullName: 'St Kitts and Nevis', rate: { monthly: 0.11, annual: 0.11 } },
  kr: { fullName: 'Korea', rate: { monthly: 0.06, annual: 0.06 } },
  kw: { fullName: 'Kuwait', rate: { monthly: 0.08, annual: 0.08 } },
  ky: { fullName: 'Cayman Islands', rate: { monthly: 0.06, annual: 0.06 } },
  kz: { fullName: 'Kazakhstan', rate: { monthly: 0.10, annual: 0.10 } },
  la: { fullName: 'Laos PDR', rate: { monthly: 0.10, annual: 0.10 } },
  lb: { fullName: 'Lebanon', rate: { monthly: 0.08, annual: 0.08 } },
  lc: { fullName: 'St Lucia', rate: { monthly: 0.06, annual: 0.06 } },
  li: { fullName: 'Liechtenstein', rate: { monthly: 0.08, annual: 0.08 } },
  lk: { fullName: 'Sri Lanka', rate: { monthly: 0.07, annual: 0.07 } },
  lr: { fullName: 'Liberia', rate: { monthly: 0.08, annual: 0.08 } },
  ls: { fullName: 'Lesotho', rate: { monthly: 0.12, annual: 0.12 } },
  lt: { fullName: 'Lithuania', rate: { monthly: 0.08, annual: 0.08 } },
  lu: { fullName: 'Luxembourg', rate: { monthly: 0.07, annual: 0.07 } },
  lv: { fullName: 'Latvia', rate: { monthly: 0.10, annual: 0.10 } },
  ly: { fullName: 'Libya', rate: { monthly: 0.11, annual: 0.11 } },
  ma: { fullName: 'Morocco', rate: { monthly: 0.09, annual: 0.09 } },
  mc: { fullName: 'Monaco', rate: { monthly: 0.18, annual: 0.18 } },
  md: { fullName: 'Moldova', rate: { monthly: 0.08, annual: 0.08 } },
  me: { fullName: 'Montenegro', rate: { monthly: 0.05, annual: 0.05 } },
  mg: { fullName: 'Madagascar', rate: { monthly: 0.08, annual: 0.08 } },
  mh: { fullName: 'Marshall Islands', rate: { monthly: 0.14, annual: 0.14 } },
  mk: { fullName: 'Macedonia', rate: { monthly: 0.10, annual: 0.10 } },
  ml: { fullName: 'Mali', rate: { monthly: 0.12, annual: 0.12 } },
  mm: { fullName: 'Myanmar', rate: { monthly: 0.13, annual: 0.13 } },
  mn: { fullName: 'Mongolia', rate: { monthly: 0.07, annual: 0.07 } },
  mo: { fullName: 'Macau', rate: { monthly: 0.08, annual: 0.08 } },
  mp: { fullName: 'Northern Mariana Islands', rate: { monthly: 0.0867, annual: 0.0867 } },
  mq: { fullName: 'Martinique', rate: { monthly: 0.20, annual: 0.20 } },
  mr: { fullName: 'Mauritania', rate: { monthly: 0.11, annual: 0.11 } },
  ms: { fullName: 'Montserrat', rate: { monthly: 0.06, annual: 0.06 } },
  mt: { fullName: 'Malta', rate: { monthly: 0.08, annual: 0.08 } },
  mu: { fullName: 'Mauritius', rate: { monthly: 0.10, annual: 0.10 } },
  mv: { fullName: 'Maldives', rate: { monthly: 0.08, annual: 0.08 } },
  mw: { fullName: 'Malawi', rate: { monthly: 0.08, annual: 0.08 } },
  mx: { fullName: 'Mexico', rate: { monthly: 0.06, annual: 0.06 } },
  my: { fullName: 'Malaysia', rate: { monthly: 0.08, annual: 0.08 } },
  mz: { fullName: 'Mozambique', rate: { monthly: 0.08, annual: 0.08 } },
  na: { fullName: 'Namibia', rate: { monthly: 0.08, annual: 0.08 } },
  nc: { fullName: 'New Caledonia', rate: { monthly: 0.17, annual: 0.17 } },
  ne: { fullName: 'Niger', rate: { monthly: 0.17, annual: 0.17 } },
  nf: { fullName: 'Norfolk Island', rate: { monthly: 0.08, annual: 0.08 } },
  ng: { fullName: 'Nigeria', rate: { monthly: 0.13, annual: 0.13 } },
  ni: { fullName: 'Nicaragua', rate: { monthly: 0.07, annual: 0.07 } },
  nl: { fullName: 'Netherlands', rate: { monthly: 0.12, annual: 0.12 } },
  no: { fullName: 'Norway', rate: { monthly: 0.10, annual: 0.10 } },
  np: { fullName: 'Nepal', rate: { monthly: 0.10, annual: 0.19 } },
  nu: { fullName: 'Niue', rate: { monthly: 0.08, annual: 0.08 } },
  nz: { fullName: 'New Zealand', rate: { monthly: 0.13, annual: 0.13 } },
  om: { fullName: 'Oman', rate: { monthly: 0.09, annual: 0.09 } },
  pa: { fullName: 'Panama', rate: { monthly: 0.07, annual: 0.07 } },
  pe: { fullName: 'Peru', rate: { monthly: 0.08, annual: 0.08 } },
  pf: { fullName: 'French Polynesia', rate: { monthly: 0.21, annual: 0.21 } },
  pg: { fullName: 'Papua New Guinea', rate: { monthly: 0.08, annual: 0.08 } },
  ph: { fullName: 'Philippines', rate: { monthly: 0.08, annual: 0.08 } },
  pk: { fullName: 'Pakistan', rate: { monthly: 0.05, annual: 0.05 } },
  pl: { fullName: 'Poland', rate: { monthly: 0.08, annual: 0.08 } },
  pm: { fullName: 'St Pierre and Miquelon', rate: { monthly: 0.14, annual: 0.14 } },
  pr: { fullName: 'Puerto Rico', rate: { monthly: 0.08, annual: 0.08 } },
  ps: { fullName: 'Palestinian Territory', rate: { monthly: 0.08, annual: 0.08 } },
  pt: { fullName: 'Portugal', rate: { monthly: 0.10, annual: 0.10 } },
  pw: { fullName: 'Palau', rate: { monthly: 0.08, annual: 0.08 } },
  py: { fullName: 'Paraguay', rate: { monthly: 0.08, annual: 0.08 } },
  qa: { fullName: 'Qatar', rate: { monthly: 0.07, annual: 0.07 } },
  re: { fullName: 'Reunion/Mayotte', rate: { monthly: 0.27, annual: 0.27 } },
  ro: { fullName: 'Romania', rate: { monthly: 0.09, annual: 0.09 } },
  rs: { fullName: 'Serbia', rate: { monthly: 0.0842, annual: 0.0842 } },
  ru: { fullName: 'Russia', rate: { monthly: 0.12, annual: 0.12 } },
  rw: { fullName: 'Rwanda', rate: { monthly: 0.08, annual: 0.08 } },
  sa: { fullName: 'Saudi Arabia', rate: { monthly: 0.05, annual: 0.05 } },
  sb: { fullName: 'Solomon Islands', rate: { monthly: 0.09, annual: 0.09 } },
  sc: { fullName: 'Seychelles', rate: { monthly: 0.14, annual: 0.14 } },
  sd: { fullName: 'Sudan', rate: { monthly: 0.08, annual: 0.08 } },
  se: { fullName: 'Sweden', rate: { monthly: 0.12, annual: 0.12 } },
  sg: { fullName: 'Singapore', rate: { monthly: 0.08, annual: 0.08 } },
  si: { fullName: 'Slovenia', rate: { monthly: 0.08, annual: 0.08 } },
  sk: { fullName: 'Slovakia', rate: { monthly: 0.12, annual: 0.12 } },
  sl: { fullName: 'Sierra Leone', rate: { monthly: 0.08, annual: 0.08 } },
  sm: { fullName: 'San Marino', rate: { monthly: 0.10, annual: 0.10 } },
  sn: { fullName: 'Senegal', rate: { monthly: 0.16, annual: 0.16 } },
  so: { fullName: 'Somalia', rate: { monthly: 0.13, annual: 0.13 } },
  sr: { fullName: 'Suriname', rate: { monthly: 0.08, annual: 0.08 } },
  ss: { fullName: 'South Sudan', rate: { monthly: 0.08, annual: 0.08 } },
  st: { fullName: 'Sao Tome and Principe', rate: { monthly: 0.16, annual: 0.16 } },
  sv: { fullName: 'El Salvador', rate: { monthly: 0.08, annual: 0.08 } },
  sy: { fullName: 'Syria', rate: { monthly: 0.08, annual: 0.08 } },
  sz: { fullName: 'Swaziland', rate: { monthly: 0.08, annual: 0.08 } },
  tc: { fullName: 'Turks and Caicos Islands', rate: { monthly: 0.06, annual: 0.06 } },
  td: { fullName: 'Chad', rate: { monthly: 0.10, annual: 0.10 } },
  tg: { fullName: 'Togo', rate: { monthly: 0.08, annual: 0.08 } },
  th: { fullName: 'Thailand', rate: { monthly: 0.08, annual: 0.08 } },
  tj: { fullName: 'Tajikistan', rate: { monthly: 0.07, annual: 0.07 } },
  tl: { fullName: 'East Timor', rate: { monthly: 0.13, annual: 0.13 } },
  tm: { fullName: 'Turkmenistan', rate: { monthly: 0.14, annual: 0.14 } },
  tn: { fullName: 'Tunisia', rate: { monthly: 0.10, annual: 0.10 } },
  to: { fullName: 'Tonga', rate: { monthly: 0.08, annual: 0.08 } },
  tr: { fullName: 'Turkey', rate: { monthly: 0.03, annual: 0.03 } },
  tt: { fullName: 'Trinidad and Tobago', rate: { monthly: 0.10, annual: 0.10 } },
  tv: { fullName: 'Tuvalu', rate: { monthly: 0.12, annual: 0.12 } },
  tw: { fullName: 'Taiwan', rate: { monthly: 0.08, annual: 0.08 } },
  tz: { fullName: 'Tanzania', rate: { monthly: 0.08, annual: 0.08 } },
  ua: { fullName: 'Ukraine', rate: { monthly: 0.11, annual: 0.11 } },
  ug: { fullName: 'Uganda', rate: { monthly: 0.08, annual: 0.08 } },
  uy: { fullName: 'Uruguay', rate: { monthly: 0.11, annual: 0.11 } },
  us: {
    fullName: 'United States',
    rate: {
      sms_monthly: 0.03,
      mms_monthly: 0.03,
      call_monthly: 0.03,
      sms_annual: 0.02,
      mms_annual: 0.02,
      call_annual: 0.02,
    },
  },
  uz: { fullName: 'Uzbekistan', rate: { monthly: 0.13, annual: 0.13 } },
  vc: { fullName: 'St Vincent Grenadines', rate: { monthly: 0.07, annual: 0.07 } },
  ve: { fullName: 'Venezuela', rate: { monthly: 0.08, annual: 0.08 } },
  vg: { fullName: 'Virgin Islands, British', rate: { monthly: 0.08, annual: 0.08 } },
  vi: { fullName: 'Virgin Islands, U.S.', rate: { monthly: 0.08, annual: 0.08 } },
  vn: { fullName: 'Vietnam', rate: { monthly: 0.12, annual: 0.12 } },
  vu: { fullName: 'Vanuatu', rate: { monthly: 0.11, annual: 0.11 } },
  wf: { fullName: 'Wallis and Futuna', rate: { monthly: 0.187, annual: 0.187 } },
  ws: { fullName: 'Samoa', rate: { monthly: 0.06, annual: 0.06 } },
  xk: { fullName: 'Kosovo', rate: { monthly: 0.11, annual: 0.11 } },
  ye: { fullName: 'Yemen', rate: { monthly: 0.11, annual: 0.11 } },
  za: { fullName: 'South Africa', rate: { monthly: 0.03, annual: 0.03 } },
  zm: { fullName: 'Zambia', rate: { monthly: 0.08, annual: 0.08 } },
  zw: { fullName: 'Zimbabwe', rate: { monthly: 0.14, annual: 0.14 } },
};

const nationalRegions = ['us', 'ca'];
export const isInternational = (region) => !nationalRegions.includes(region);
